import { motion } from "framer-motion";
import { SITE } from "../config";

export const Countdown = () => {
  return (
    <section id="launch" data-testid="countdown-section" className="relative bg-[#0a0805] py-20 md:py-28 overflow-hidden">
      <div className="pointer-events-none absolute inset-0" style={{ background: "radial-gradient(70% 100% at 50% 0%, rgba(216,171,78,0.16), transparent 60%)" }} />
      <div className="relative max-w-[1200px] mx-auto px-6 md:px-12 text-center">
        <motion.p initial={{ opacity: 0, y: 20 }} whileInView={{ opacity: 1, y: 0 }} viewport={{ once: true }} transition={{ duration: 0.6 }} className="font-grotesk uppercase tracking-[0.35em] text-xs text-[#d8ab4e] mb-8">
          Now Available
        </motion.p>

        <motion.h2 initial={{ opacity: 0, y: 20 }} whileInView={{ opacity: 1, y: 0 }} viewport={{ once: true }} transition={{ duration: 0.6, delay: 0.1 }} data-testid="countdown-live" className="font-display text-4xl sm:text-6xl gold-text italic mb-8">
          The New Golden Age is here.
        </motion.h2>

        <motion.p initial={{ opacity: 0, y: 20 }} whileInView={{ opacity: 1, y: 0 }} viewport={{ once: true }} transition={{ duration: 0.6, delay: 0.15 }} className="font-body text-[#a89d84] text-lg max-w-xl mx-auto mb-10">
          Available now on Amazon in Kindle eBook and Paperback — order your copy today.
        </motion.p>

        <motion.a
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.6, delay: 0.2 }}
          href={SITE.amazonUrl}
          target="_blank"
          rel="noopener noreferrer"
          data-testid="countdown-buy-btn"
          className="group inline-flex items-center justify-center gap-2 bg-[#d8ab4e] text-[#0a0805] px-10 py-4 font-semibold uppercase tracking-widest hover:bg-[#f2c968] transition-colors"
        >
          {SITE.amazonLabel}
          <span className="inline-block transition-transform group-hover:translate-x-1">→</span>
        </motion.a>
      </div>
    </section>
  );
};

export default Countdown;
